import { atom } from "recoil";
import { NavigationItem } from "../../components/NavButton";
import { useNestedApp } from "./useNestedApp";

export type AppUiLocations = "leftTray" | "rightTray";

export type AppState = {
    selectedTeam: string|undefined,
    loaded: string[]
    nestedApps: {
        [key: string]: ReturnType<typeof useNestedApp>
    },
    menu: {
        isOpen: boolean,
    },
    ui: {
        [key in AppUiLocations]: JSX.Element | undefined;
    },
    navigation: NavigationItem[]
}

export const appState = atom<AppState>({
    key: "appState",
    default: {
        selectedTeam: undefined,
        loaded: [],
        nestedApps: {},
        menu: {
            isOpen: false,
        },
        ui: {
            leftTray: undefined,
            rightTray: undefined,
        },
        navigation: []
    },
})